query GetDefaultTimezone {
  notifyTimes(first: 1, orderBy: _CREATED_DATE_DESC) {
    nodes {
      timeZoneId
    }
  }
}
